<template>
  <div class="home">
    <!-- 骨架框 -->
    <Skeleton v-if="skeletonShow"></Skeleton>
    <!-- 消息通知栏 -->
    <NoticeBar></NoticeBar>
    <!-- 子级路由 -->
    <keep-alive :include="keepName">
      <router-view></router-view>
    </keep-alive>
    <!-- 音乐播放器 -->
    <Music></Music>
    <!-- 搜索框 -->
    <div class="searchView">
      <component v-show="searchShow" :is="topic"></component>
    </div>
    <!-- Wxtips -->
    <Wxtips v-if="isWeixin=='false' && wxtipsShow"></Wxtips>
    <!-- 微信公众号 -->
    <WxGzhTips v-if="isWeixin=='true' && wxGzhTipsShow"></WxGzhTips>
    <!-- 背景图 -->
    <Bgimg></Bgimg>
    <!-- 漂浮物 -->
    <FloatImg></FloatImg>
    <!-- 图片旋转验证码 -->
    <ImgRotate></ImgRotate>
    <Vue2verify></Vue2verify>
    <NoborderAD></NoborderAD>

    <!-- 嵌入抽奖代码 -->
    <van-overlay class="iframebox" :show="iframeShow" @click="closeCj">
      <div class="iframebody">
        <div class="closeicon" @click="closeCj"><van-icon name="close" /></div>
        <iframe v-if="iframeShow" :src="linkUrl" id="iframe" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  const component={}
  const files = require.context("@/components",true,/\Search.vue/);
  files.keys().forEach(key => {
    // 组件实例
    const reqCom = files(key);
    // 截取路径作为组件名
    // const reqComName = reqCom.default.name;
    const reqComName = key.replace(/\.\/(.*)\.vue/,'$1').split('/')[0];
    // 截取组件去扩展名后, 添加到组件对象
    component[reqComName] = reqCom.default || reqCom;
  });
  import {mapState,mapMutations} from "vuex"
  import {topnum,zclick} from "@/api/api.js"
  import {getmobileinfo} from "@/utils/utils.js"
  import Music from "@/components/com/Music.vue"
  import Bgimg from "@/components/com/Bgimg.vue"
  import Wxtips from "@/components/com/Wxtips.vue"
  import Skeleton from "@/components/com/Skeleton.vue"
  import FloatImg from "@/components/com/FloatImg.vue"
  import NoticeBar from "@/components/com/NoticeBar.vue"
  import ImgRotate from "@/components/com/ImgRotate.vue"
  import WxGzhTips from "@/components/com/WxGzhTips.vue"
  import Vue2verify from "@/components/com/Vue2verify.vue"
  import NoborderAD from "@/components/com/NoborderAD.vue"


  export default {
    components:Object.assign(component,{
      Music,
      NoticeBar,
      Wxtips,
      WxGzhTips,
      Bgimg,
      Skeleton,
      FloatImg,
      ImgRotate,
      Vue2verify,
      NoborderAD
    }),
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')),
        isWeixin:sessionStorage.getItem('isWeixin'),
        keepName:['Vote','Rank'],
        // linkUrl:'http://192.168.10.17:9020/#/?ac_id='
      }
    },
    async created(){
      if(sessionStorage.getItem('isWeixin')=='true' && localStorage.getItem('wxInfo')){
        await this.clickAdd()
      }
      await this.getTopNum()
    },
    methods:{
      ...mapMutations('activeData',['changeValue']),
      //获取头部数量
      async getTopNum(){
        const res= await topnum({action_id:this.info.id})
        if(res.data.code==1){
          this.changeValue([
            {name:'zvoteNumber',value:Number(res.data.data.votenum)},
            {name:'zClick',value:Number(res.data.data.click)}
          ])
        }
      },
      //增加访问量
      async clickAdd(){
        await zclick({
          action_id:JSON.parse(sessionStorage.getItem('info')).id,
          openid:JSON.parse(localStorage.getItem('wxInfo')).openid,
          unionid:JSON.parse(localStorage.getItem('wxInfo')).unionid,
          device:getmobileinfo()
        })
      },

      // 关闭抽奖弹窗
      closeCj(){
        this.$store.commit('cjData/SET_IFRAMESHOW',false)
      },

    },
    computed:{
      ...mapState('activeData',['topic']),
      ...mapState('showData',['searchShow','wxtipsShow','wxGzhTipsShow','skeletonShow']),
      ...mapState({
        iframeShow:state=>state.cjData.iframeShow,
        linkUrl:state=>state.cjData.linkUrl,
      }),

    //   linkUrl(){
    //     alert(2)
    //     // let link = 'http://192.168.10.17:9020/#/?wxinfo=' + encodeURI(localStorage.getItem('wxInfo'));
    //     let link = 'http://cj.apphaitao.com?wxinfo=' + encodeURI(localStorage.getItem('wxInfo'));
    //     let mobiledomin = JSON.parse(sessionStorage.getItem('site')).mobiledomin
    //     alert(3)
    //     let domins = mobiledomin.split('.')
    //     alert(4)
    //     domins[0]='api'
    //     alert(5)
    //     mobiledomin = domins.join('.')
    //     alert(link +'&mobiledomin='+mobiledomin)
    //     // let openId = JSON.parse(localStorage.getItem('wxInfo')).openid
    //     return link +'&mobiledomin='+mobiledomin
    //     // return link +'&mobiledomin='+mobiledomin
    //   }
    }
  }
</script>

<style lang="less" scoped>
.home{
  width: 100%;
  height: 100%;
  // padding-bottom: 1.6rem;
}

.iframebody{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed; 
  right: 0; 
  bottom: 0; 
  left: 0; 
  top: 0; 
  -webkit-overflow-scrolling: touch; 
  overflow-y: scroll; 

  iframe{
     height: 100%; width: 100%;
  }
  .closeicon{
    position: absolute;
    top: 0;
    right: 0;
    color: white;
  }
}
</style>
